import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useSearchManualApplicationsStore } from '@lib/store';
import { useDebounce } from '@shared/hooks';
import type { ManualApplicationSearchParams } from '@shared/api';
import { Input } from '@shared/widgets';

export const ManualApplicationSearchForm = () => {
  const { searchManualApplications } = useSearchManualApplicationsStore();

  const [filters, setFilters] = useState<ManualApplicationSearchParams>({});

  const debouncedFilters = useDebounce(filters);
  useEffect(() => {
    searchManualApplications(debouncedFilters);
  }, [debouncedFilters]);

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <Grid container>
        <Grid item xs={12}>
          <Input
            name='keyword'
            label='Application Reference'
            fullWidth
            value={filters.name || ''}
            onChange={(e) => setFilters((prev) => ({ ...prev, name: e.target.value }))}
          />
        </Grid>
      </Grid>
    </form>
  );
};
